import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { TextBody } from 'web-ui-components/lib/atoms/text';
import { Card } from 'web-ui-components/lib/organisms/cards';
import { Button } from 'web-ui-components/lib/atoms/buttons';
import { DataTable } from 'web-ui-components/lib/molecules/tables';
import { SubHeading } from 'web-ui-components/lib/typography/headings';
import { Icon } from 'web-ui-components/lib/atoms/iconography';
import { Identifier } from 'web-ui-components/lib/typography/modifiers';
import { getMyPostCutOffPayments } from '../../states/payments/builders';
import { expiredPaymentsColumns } from '../../config/';
import { hideExpired } from '../../states/payments/actions';
import { expireMultiplePayments } from '../../states/page/actions';

const mapState = (state) => ({
	postCutOffPayments: getMyPostCutOffPayments(state),
});

const mapDispatch = (dispatch) => ({
	handleClose: () => dispatch(hideExpired()),
	expireMultiplePayments: (postCutOffPayments) => dispatch(expireMultiplePayments(postCutOffPayments)),
});

const formatPostCutOffPayments = (postCutOffPayments) =>
	postCutOffPayments.map((cutOffPayment) => ({
		...cutOffPayment,
		to: <Identifier.Breaking>{cutOffPayment.to}</Identifier.Breaking>,
		reference: <Identifier.Truncated characterCount={6} value={cutOffPayment.reference} />,
	}));

const ExpiredPayments = ({
	postCutOffPayments,
	handleClose,
	expiredTitle,
	expiredSubText,
	expiredReminderText,
	expiredCloseButtonText,
	expireMultiplePayments,
}) => {
	const formattedPostCutOffPayments = formatPostCutOffPayments(postCutOffPayments);
	return (
		<Card type="warning" bordered className="u-margin-bottom-2">
			<div className="u-flex u-flex-justify-content-space-between">
				<div className="u-flex u-flex-align-items-center u-margin-bottom-1">
					<Icon size="lg" iconType="ExclamationCircleLarge" className="u-margin-right-1" />
					<SubHeading>{expiredTitle}</SubHeading>
				</div>

				<Button
					id="expired-close-button"
					width="flush"
					display="secondary"
					onClick={() => {
						expireMultiplePayments(postCutOffPayments);
						handleClose();
					}}
				>
					{expiredCloseButtonText}
				</Button>
			</div>

			<TextBody>
				<p>{expiredSubText}</p>
				<p>{expiredReminderText}</p>
			</TextBody>

			<DataTable
				layout="transactions"
				isBranded
				columns={expiredPaymentsColumns}
				data={formattedPostCutOffPayments}
				keyPath={['id']}
			/>
		</Card>
	);
};

ExpiredPayments.propTypes = {
	postCutOffPayments: PropTypes.arrayOf(PropTypes.shape({})),
	expireMultiplePayments: PropTypes.func.isRequired,
	handleClose: PropTypes.func.isRequired,
	expiredTitle: PropTypes.string.isRequired,
	expiredSubText: PropTypes.string.isRequired,
	expiredReminderText: PropTypes.string.isRequired,
	expiredCloseButtonText: PropTypes.string.isRequired,
};

export default connect(mapState, mapDispatch)(ExpiredPayments);
